
import React, {useState, useEffect} from 'react';
import { Form, Button, Row, Col, Spinner } from 'react-bootstrap';
import axios from 'axios'
import {Break} from '@alanngo/custom-components/dist';
const TechSupport = () => 
{
    const [email, setEmail] = useState("")
    const [phone, setPhone] = useState(0)
    const [mssg, setMssg] = useState("")
    const [loaded, setLoaded] = useState(false)

    useEffect(()=>
    {
        let url ='https://flask-mail-4732.herokuapp.com'
        axios.get(url).then(res =>setLoaded(res.data.loaded)).then(console.log('success'))
    }, [loaded])

    const validateEmail = (arg) => arg.match(/^[^\s@]+@[^\s@]+$/) && email
    const validatePhone = (arg) => 
    (
        arg.match(/[0-9]{10}/) || 
        arg.match(/[0-9]{3}-[0-9]{3}-[0-9]{4}/)
    )
    const handleSubmit = (e) =>
    {
        e.preventDefault()
        if (!validateEmail(email))
            alert("Invalid Email!")
        if (!phone ||!validatePhone(phone))
            alert("Invalid Phone!")
        if (!mssg)
            alert("Please provide a description of your problem")
        else
        {
            let url ='https://flask-mail-4732.herokuapp.com/email'
            let body = 
            {
                "user": "p.star.uh@gmail.com",
                "password": 'gozqmedquveshcyx',
                "reciever": "alanngo673@gmail.com",
                "mssg":mssg,
                "subject":`${email}: ${phone}`
            }
            axios.post(url, body).then(res => console.log(res.data)).then(()=>alert('successfully submitted request')).catch(err => alert(String(err)))
        }
    }
    return (
        <div className='TechSupport' align="center">
        <Break />
            <Form>
                <Form.Group as={Row} >
                    <Col >
                        <Form.Control type="email" placeholder="Email" onChange = {(e) =>setEmail(e.target.value)} name="email"/>
                    </Col>
                    <Col >
                        <Form.Control type="phone" placeholder="Phone number" onChange = {(e) =>setPhone(e.target.value)} name="phone"/>
                    </Col>
                </Form.Group>
                <Break />
                <Form.Control as="textarea" rows={5} placeholder="Tell us about your problem" onChange = {(e) =>setMssg(e.target.value)} name="message"/>
            </Form>
            <Break/>
            <Row>
                <Col><Button variant="primary" href="/welcome"><h2>Go Back</h2></Button></Col>
                <Col>{(loaded)?<Button variant="success" onClick={handleSubmit}><h2>Submit</h2></Button>:<Spinner animation="border" variant="success" />}</Col>
            </Row>
            
        </div>
    )
}

export default TechSupport;
